import { Box, Typography, Slider } from "@mui/material";

const YoutubeRange = ({ min, max, onMinChange, onMaxChange }) => {
  return (
    <Box mb={4}>
      <Typography variant="h6">Youtube Exploration (Per Session)</Typography>

      <Slider
        value={[min, max]}
        onChange={(e, val) => {
          onMinChange(val[0]);
          onMaxChange(val[1]);
        }}
        valueLabelDisplay="auto"
        min={1}
        max={20}
      />
    </Box>
  );
};

export default YoutubeRange;
